import { MenuAnchorOrigin } from '../Menu/Menu.constants';
export const SAFE_DISTANCE_FROM_WINDOW_BORDER = 16;
export const PopoverPosition = {
  OVER: 'over',
  BELOW: 'below'
};
export const PopoverAnchorOrigin = {
  ...MenuAnchorOrigin,
  RIGHT: 'right'
};
export { TooltipPlacement as PopoverPlacement, TooltipVariant as PopoverColor } from '../Tooltip/Tooltip.constants';